import React from 'react';


const Processing = () => (
  <div className="row">
    <div align="center">
      <label>
        Processing...
      </label>
    </div>
    <br />
  </div>
);

export default Processing;


// WEBPACK FOOTER //
// ./app/javascript/components/subscription_plan/components/UI/Processing.js